import { PermissionGuard } from '@/app/auth/guards/permission.guard';
import { inject } from '@angular/core';
import { Route } from '@angular/router';

export const OnsiteRoutes: Route = {
    path: 'onsite',
    data: { title: 'onsite-app' },
    children: [
        {
            path: '',
            pathMatch: 'full',
            redirectTo: 'groups',
        },
        {
            path: 'groups',
            loadComponent: () =>
                import('./on-site-groups/on-site-groups.component').then((m) => m.OnSiteGroupsComponent),
            data: { title: 'onsite-groups' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'group-contracts',
            loadComponent: () =>
                import('./on-site-group-contracts/on-site-group-contracts.component').then(
                    (m) => m.OnSiteGroupContractsComponent,
                ),
            data: { title: 'onsite-group-contracts' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'group-users',
            loadComponent: () =>
                import('./on-site-group-users/on-site-group-users.component').then((m) => m.OnSiteGroupUsersComponent),
            data: { title: 'onsite-group-users' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
    ],
};
